(function () {
  if(document.body.id !== 'about') return false

  aboutMessage()

  function aboutMessage() {
    var trigger = document.querySelector('.js-about-message-trigger')
    if(!trigger) return false

    trigger.addEventListener('click', showMessage)
    var messageContainer = document.querySelector('.js-about-message-container')
    var message= messageContainer.querySelector('.js-about-message')

    function showMessage() {
      trigger.classList.add('is-show')
      messageContainer.classList.add('is-show')
      setMessageHeight()
      window.addEventListener('resize', resize)

      trigger.removeEventListener('click', showMessage)
      trigger.addEventListener('click', hideMessage)

    }


    function hideMessage() {
      trigger.classList.remove('is-show')
      messageContainer.classList.remove('is-show')
      messageContainer.style.height = ''
      window.removeEventListener('resize', resize)

      trigger.removeEventListener('click', hideMessage)
      trigger.addEventListener('click', showMessage)
    }


    function setMessageHeight() {
      messageContainer.style.height = ''
      var messageH = message.scrollHeight
      messageContainer.style.height = messageH + 'px'
    }

    var currentWidth
    function resize() {
      if (currentWidth == window.innerWidth) {
        return
      }
      setMessageHeight()
      currentWidth = window.innerWidth
    }
  }
}());